import { useRef } from "react";
import { BaseModel } from "../../../../utilities/data/model/Base";

export function useRegistryMaintainer<T extends BaseModel>(items: T[]) {
  const registry = useRef<Map<string, T>>(new Map());

  for (const item of items) {
    registry.current.set(item.id, item);
  }

  function getById(id: string) {
    const res = registry.current.get(id);
    if (!res) {
      throw new Error(
        `Dependency not found in dependency registry for id: ${id}`
      );
    }
    return res;
  }

  return {
    registry: registry.current,
    getById,
  };
}
